import { GenerateDevicePayload } from '@src/types/Device';
import { DeviceType } from '@src/types/devices/Device.types';

const generateDevices: GenerateDevicePayload = {
  siteControllerId: '000000F',
  unitControllers: {
    engineeringIds: [
      '0000001F',
      '0000002F',
      '0000003F',
      '0000004F',
      '0000005F',
      '0000006F',
      '0000007F',
      '0000008F',
      '0000009F',
      '000000AF',
      '000000BF',
      '0000012F',
    ],
    namePrefix: 'Unit ',
    nameSuffix: '',
  },
  sourceDevices: [
    {
      type: DeviceType.TSC,
      parentType: DeviceType.SITE_CONTROLLER,
      count: 4,
    },
    {
      type: DeviceType.POWIN_EMS,
      parentType: DeviceType.SITE_CONTROLLER,
      count: 4,
    },
    {
      type: DeviceType.POWIN_BESS,
      parentType: DeviceType.POWIN_EMS,
      count: 4,
    },
    {
      type: DeviceType.POWIN_RACK,
      parentType: DeviceType.POWIN_BESS,
      count: 4,
    },
    {
      type: DeviceType.METER_POINT,
      parentType: DeviceType.TSC,
      count: 4,
      namePrefix: 'Megapack',
    },
    {
      type: DeviceType.BMS,
      parentType: DeviceType.UNIT_CONTROLLER,
      count: 4,
    },
    {
      type: DeviceType.RACK,
      parentType: DeviceType.BMS,
      count: 2,
    },
    {
      type: DeviceType.METER,
      parentType: DeviceType.SITE_CONTROLLER,
      count: 2,
    },
    {
      type: DeviceType.PCS,
      parentType: DeviceType.UNIT_CONTROLLER,
      count: 2,
    },
  ],
};

export default generateDevices;
